import Itinerary from './itinerary.model';

export default class SearchBody {
    filters: Filters;
    itinerary: Array<Itinerary>;
    airlines?: Array<string>;
    travelers: Travelers;
    currency: string;

    constructor() {
        this.filters = {
            airport_change: false,
            alliance: [],
            cabin: '',
            cluster: false,
            flexible_dates: false,
            hub: false,
            include_nearby: false,
            round_trip: false,
        };
        this.itinerary = Array<Itinerary>();
        this.airlines = Array<string>() ;
        this.travelers = {
            A: 1,
            C: 0,
            I: 0,
        };
        this.currency = '';
    }
}
export interface Filters {
    airport_change: boolean,
    alliance: Array<string>,
    cabin: string,
    cluster: boolean,
    flexible_dates: boolean,
    hub: boolean,
    include_nearby: boolean,
    round_trip: boolean
}
export interface Travelers {
    A: number,
    C: number,
    I: number,
}
